import { render, staticRenderFns } from "./PendingSubmission.vue?vue&type=template&id=2b63722d&scoped=true&"
import script from "./PendingSubmission.vue?vue&type=script&lang=js&"
export * from "./PendingSubmission.vue?vue&type=script&lang=js&"
import style0 from "@/assets/css/viewclients.css?vue&type=style&index=0&lang=css&"
import style1 from "./PendingSubmission.vue?vue&type=style&index=1&id=2b63722d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b63722d",
  null
  
)

export default component.exports